import React from 'react';
import Brochures from './Brochures';

const BrochuresMaster = () => <Brochures fixedCategory="master" />;

export default BrochuresMaster;
